import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import setPlanDescription from "../../../store/plan/actions/setPlanDescription";
import setPlanTitle from "../../../store/plan/actions/setPlanTitle";
import addAudio from "../../../store/plan/actions/addAudio";
import removeAudio from "../../../store/plan/actions/removeAudio";
import { post } from "../../../actions/general";

import MiddleRow from "./MiddleRow";

export default connect(null, { setPlanDescription, setPlanTitle, addAudio, removeAudio, post })(injectIntl(MiddleRow));
